import { useState } from "react";
import { logActivity } from "../ActivityLog";

const C = {
  surface2:"#202020", border:"#2a2a2a", muted:"#666",
  orange:"#FF5F1F", magenta:"#E8197D", white:"#fff",
  green:"#4ade80", gold:"#F5A623", red:"#f87171",
};

const inp = (x={}) => ({ background:C.surface2, border:`0.5px solid ${C.border}`, borderRadius:8, padding:"9px 12px", color:C.white, fontSize:16, outline:"none", width:"100%", boxSizing:"border-box", ...x });
const btn = (v="primary",x={}) => ({ padding:"8px 16px", borderRadius:8, fontSize:13, fontWeight:500, cursor:"pointer", border:"none", boxSizing:"border-box", ...(v==="primary"?{background:`linear-gradient(135deg,${C.orange},${C.magenta})`,color:C.white}:{}), ...(v==="ghost"?{background:"none",border:`0.5px solid ${C.border}`,color:C.muted}:{}), ...x });

export function TodoEditor({ todos, onChange, editing, onToggle, currentUser, project }) {
  const [title,setTitle]=useState("");
  const [deadline,setDeadline]=useState("");
  const [editingId,setEditingId]=useState(null);
  const [editTitle,setEditTitle]=useState("");
  const [editDeadline,setEditDeadline]=useState("");

  const add=()=>{
    if(!title.trim()) return;
    onChange([...todos,{id:Date.now(),title,deadline,done:false,createdBy:currentUser?.id,createdByInitials:currentUser?.initials}]);
    if(currentUser) logActivity(currentUser,'todo_added',{todo_text:title,event_name:project?.name},'detail');
    setTitle(""); setDeadline("");
  };

  const startEdit=(t)=>{ setEditingId(t.id); setEditTitle(t.title); setEditDeadline(t.deadline||""); };
  const saveEdit=()=>{ if(!editTitle.trim()) return; onChange(todos.map(x=>x.id===editingId?{...x,title:editTitle,deadline:editDeadline}:x)); setEditingId(null); };
  const cancelEdit=()=>setEditingId(null);

  const fmtDate=d=>new Date(d+"T12:00:00").toLocaleDateString("nb-NO",{day:"numeric",month:"short",year:"numeric"});
  const isOverdue=d=>d&&new Date(d+"T23:59:59")<new Date();
  const isDueSoon=d=>{ if(!d) return false; const diff=new Date(d+"T23:59:59")-new Date(); return diff>0&&diff<3*24*60*60*1000; };

  return (
    <div>
      {todos.map(t=>(
        <div key={t.id} style={{marginBottom:8}}>
          {editingId===t.id
            ? <div style={{padding:"10px 12px",background:C.surface2,borderRadius:8,border:`0.5px solid ${C.orange}44`}}>
                <div style={{display:"flex",gap:8,marginBottom:8}}>
                  <input style={inp({flex:1})} value={editTitle} onChange={e=>setEditTitle(e.target.value)} onKeyDown={e=>e.key==="Enter"&&saveEdit()} autoFocus/>
                  <input style={inp({width:130,flexShrink:0})} type="date" value={editDeadline} onChange={e=>setEditDeadline(e.target.value)}/>
                </div>
                <div style={{display:"flex",gap:8}}>
                  <button style={btn("primary",{padding:"5px 14px",fontSize:12})} onClick={saveEdit}>Lagre</button>
                  <button style={btn("ghost",{padding:"5px 14px",fontSize:12})} onClick={cancelEdit}>Avbryt</button>
                </div>
              </div>
            : <div style={{display:"flex",alignItems:"flex-start",gap:10,padding:"10px 12px",background:C.surface2,borderRadius:8,opacity:t.done?0.5:1}}>
                <div onClick={()=>editing?onChange(todos.map(x=>x.id===t.id?{...x,done:!x.done}:x)):onToggle(t.id)} style={{width:18,height:18,borderRadius:4,border:`1.5px solid ${t.done?C.green:C.border}`,background:t.done?C.green:"transparent",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",flexShrink:0,marginTop:1}}>
                  {t.done&&<svg width="10" height="10" viewBox="0 0 12 12" fill="none" stroke="#000" strokeWidth="2"><path d="M2 6l3 3 5-5"/></svg>}
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:13,textDecoration:t.done?"line-through":"none",color:t.done?C.muted:C.white}}>{t.title}</div>
                  {t.deadline&&<div style={{fontSize:11,marginTop:3,color:isOverdue(t.deadline)?C.red:isDueSoon(t.deadline)?C.gold:C.muted}}>
                    {isOverdue(t.deadline)?"⚠ Utgått: ":isDueSoon(t.deadline)?"⏰ Snart: ":""}{fmtDate(t.deadline)}
                  </div>}
                </div>
                {t.createdByInitials&&<div style={{fontSize:10,color:C.muted,flexShrink:0,padding:"0 4px"}}>{t.createdByInitials}</div>}
                <button onClick={()=>startEdit(t)} style={{background:"none",border:"none",color:"#555",cursor:"pointer",fontSize:13,flexShrink:0,padding:"0 4px"}} title="Rediger">✎</button>
                <button onClick={()=>onChange(todos.filter(x=>x.id!==t.id))} style={{background:"none",border:"none",color:"#555",cursor:"pointer",fontSize:18,flexShrink:0}}>×</button>
              </div>}
        </div>
      ))}
      <div style={{display:"flex",flexDirection:"column",gap:8,marginTop:10}}>
        <input style={inp({})} placeholder="Ny oppgave..." value={title} onChange={e=>setTitle(e.target.value)} onKeyDown={e=>e.key==="Enter"&&add()}/>
        <div style={{display:"flex",gap:8}}>
          <input style={inp({flex:1})} type="date" value={deadline} onChange={e=>setDeadline(e.target.value)}/>
          <button style={btn("primary",{flexShrink:0})} onClick={add}>+ Legg til</button>
        </div>
      </div>
      {todos.length===0&&<div style={{fontSize:13,color:"#444",marginTop:8}}>Ingen to-dos enda.</div>}
    </div>
  );
}